// extracted by mini-css-extract-plugin
export default {"text":"OutDataMessage_text__jwlv8"};